import React, { useState, Fragment } from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import {
  AlignLeft, Maximize, Bell, MessageCircle, MoreHorizontal, ZapOff, Crosshair,
} from 'react-feather';
import { translate } from 'react-switch-lang';
import { observer } from 'mobx-react';
import * as PropTypes from 'prop-types';
// import logo from '../../../../images/20070-2-small.png';
import { UncontrolledTooltip } from 'reactstrap';
import logo from '../../../../images/logoglobenew.png';
import Language from './language';
import UserMenu from './userMenu';
import Notification from './notification';
import SearchHeader from './searchHeader';
import { EN } from '../../../constant';
import appState from '../../../storages/mobx/appState';
import LanguageIndicator from './LanguageIndicator';
import MaximizeBrowserButton from '../../../components/buttons/MaximizeBrowserButton';
import HandlebearsEmptySearchResults from '../../../handlebears/HandlebearsEmptySearchResults';
import NotificationStatus from '../../../components/NotificationStatus';
import authStorage from '../../../storages/mobx/authStorage';
import chatStorage from '../../../pages/Chat/chatStorage';

const Header = ({ t }) => {
  const [headerbar, setHeaderbar] = useState(true);

  const mainHeaderClass = classnames({
    'page-main-header': true,
    open: !appState.isSidebarOpened,
  });

  return (
    <>
      <div className={mainHeaderClass}>
        <div className="main-header-right row">
          <div className="main-header-left d-lg-none">
            <div className="logo-wrapper">
              <Link to="/app/dashboard">
                <img className="img-fluid" src={logo} alt="" />
              </Link>
            </div>
          </div>
          <div className="mobile-sidebar d-block">
            <div className="media-body text-right switch-sm">
              <label className="switch">
                <a href="#javascript" onClick={appState.toggleSidebar}>
                  <AlignLeft />
                </a>
              </label>
            </div>
          </div>
          <NotificationStatus />
          <div className="nav-right col p-0">
            <ul className={`nav-menus ${headerbar ? '' : 'open'}`}>
              <li>
                <SearchHeader />
              </li>
              <li>
                <UncontrolledTooltip placement="top" target="invite-user">
                  Invite
                </UncontrolledTooltip>
                <Crosshair id="invite-user" onClick={() => chatStorage.getManagerInviteLink(authStorage.id)} />
              </li>
              <li>
                <MaximizeBrowserButton id="header-fullscreen" title={t('global.Go to fullscreen mode')} />
              </li>
              <li className="onhover-dropdown">
                <a className="txt-dark" href="#">
                  <LanguageIndicator />
                </a>
                {/* <Language /> */}
              </li>
              {/* <li className="onhover-dropdown"> */}
              {/*  <Notification /> */}
              {/*  <Bell /> */}
              {/*  <span className="dot" /> */}
              {/*  <Notification /> */}
              {/* </li> */}
              {/* <li> */}
              {/*  <a href="#javascript" onClick={appState.toggleRightSidebar}> */}
              {/*    <MessageCircle /> */}
              {/*    <span className="dot" /> */}
              {/*  </a> */}
              {/* </li> */}
              <UserMenu />
            </ul>
            <div className="d-lg-none mobile-toggle pull-right" onClick={() => setHeaderbar(!headerbar)}>
              <MoreHorizontal />
            </div>
          </div>
          <script id="result-template" type="text/x-handlebars-template">
            <div className="ProfileCard u-cf">
              <div className="ProfileCard-avatar">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-airplay m-0"
                >
                  <path d="M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1" />
                  <polygon points="12 15 17 21 7 21 12 15" />
                </svg>
              </div>
              <div className="ProfileCard-details">
                <div className="ProfileCard-realName" />
              </div>
            </div>
          </script>
          <HandlebearsEmptySearchResults />
        </div>
      </div>
    </>
  );
};
export default translate(observer(Header));
